import { AppContent } from '../AppContent';
import { MetaContentValues } from '../metaContentValues';

const hmo: AppContent['hmo'] = {
  metaContent: {
    title: MetaContentValues.home.title,
  },
  backLabel: 'Back to Landlord support',
  title: 'Houses in Multiple Occupation (HMO)',
  aHmoIs:
    'A HMO is where you let out a property to three or more tenants who form more than one household. A household can be a single person or members of the same family living together. The tenants will usually share a kitchen, bathroom, and toilet.',
  needALicence:
    "You need a licence if your HMO has five or more people. Some councils ask for other types of HMOs to be licenced. Councils must also carry out a Housing Health and Safety Rating System (HHSRS) risk assessment on your HMO within five years of receiving a licence application. If any unacceptable risks are found, it's up to you to deal with them.",
  unlimitedFineTitle:
    'You could get an unlimited fine for renting out an unlicensed HMO',
  youCouldBeFined:
    'You could also be fined up to £20,000 if you exceed the number of tenants allowed by your licence. And continue to be fined for every day this continues after your first fine. If you break anything to do with your licence, you could be fined up to £10,000. ',
  hmoLicenceLinkLabel: 'Do I need an HMO licence?',
  hmoLicenceLinkHref:
    'https://www.gov.uk/private-renting/houses-in-multiple-occupation',
  mustTellLocalCouncil:
    "You must tell your local council if you or your tenants make or are planning to make any changes to your HMO. A change in your tenants' circumstances, like the birth of a child for example, must also be reported.",
  hmoInWales: {
    title: 'HMOs in Wales',
    mandatoryLicence:
      'Licensing is mandatory for all HMOs with three or more storeys and are occupied by five or more persons forming two or more households.',
    localCouncils:
      'Local councils are responsible for licensing of HMOs in Wales.',
  },
  hmoInScotland: {
    title: 'HMOs in Scotland',
    makeSure: "Make sure you're ",
    hmoLicenceLinkLabel: 'registered as a landlord and have an HMO licence',
    hmoLicenceLinkHref: 'https://www.landlordregistrationscotland.gov.uk',
    couldBeFined:
      ', or you could be fined up to £50,000. You can also apply to the ',
    accreditationLinkLabel: 'Landlord Accreditation Scotland',
    accreditationLinkHref:
      'https://landlordaccreditationscotland.com/landlord-accreditation',
    committedToMaking:
      " scheme. This shows you're committed to making your HMO a certain standard which could make it more desirable to tenants.",
  },
  hmoInNorthernIreland: {
    title: 'HMOs in Northern Ireland',
    letOutProperty: 'To let out your property as an HMO in Northern Ireland ',
    getALicenceLinkLabel: 'you must get a licence',
    getALicenceLinkHref:
      'https://www.gov.uk/house-in-multiple-occupation-northern-ireland',
    lastFiveYears:
      ". These normally last five years, after which you'll need to reapply.",
  },
};

export default hmo;
